var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftSidebarExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7905_50344)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1528 15.1081C23.1513 15.1096 23.1498 15.1112 23.1483 15.1127C23.0533 15.2103 23 15.3411 23 15.4774C23 15.6159 23.055 15.7487 23.1528 15.8467C23.2011 15.8956 23.2586 15.9343 23.322 15.9606C23.3854 15.9869 23.4535 16.0003 23.5221 16C23.5908 16.0003 23.6588 15.9869 23.7222 15.9606C23.7857 15.9343 23.8432 15.8956 23.8914 15.8467L27.3754 12.3628C27.4732 12.2648 27.5282 12.132 27.5282 11.9935C27.5282 11.855 27.4732 11.7222 27.3754 11.6242L23.8914 8.14026C23.7924 8.04795 23.6613 7.99769 23.5259 8.00008C23.3906 8.00247 23.2614 8.05732 23.1656 8.15306C23.0699 8.24881 23.015 8.37798 23.0127 8.51337C23.0103 8.64876 23.0605 8.77978 23.1528 8.87885L26.2675 11.9935L23.1528 15.1081Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 6C3.25 5.58579 3.58579 5.25 4 5.25H19.0684C19.4826 5.25 19.8184 5.58579 19.8184 6C19.8184 6.41421 19.4826 6.75 19.0684 6.75H4C3.58579 6.75 3.25 6.41421 3.25 6ZM3.25 12C3.25 11.5858 3.58579 11.25 4 11.25H19.0684C19.4826 11.25 19.8184 11.5858 19.8184 12C19.8184 12.4142 19.4826 12.75 19.0684 12.75H4C3.58579 12.75 3.25 12.4142 3.25 12ZM3.25 18C3.25 17.5858 3.58579 17.25 4 17.25H19.0684C19.4826 17.25 19.8184 17.5858 19.8184 18C19.8184 18.4142 19.4826 18.75 19.0684 18.75H4C3.58579 18.75 3.25 18.4142 3.25 18Z",
    fill: "#424242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7905_50344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.8186,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSidebarExpand);
export default __webpack_public_path__ + "static/media/left-sidebar-expand.d2f79078920ad273699b6431fdd3eaaa.svg";
export { ForwardRef as ReactComponent };